module.exports = __webpack_public_path__ + "mensagens.png?5fae12d5bc2a8f8ddf9ddc014f6009af";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mensagens.png
// module id = 747
// module chunks = 0